import styled from '@emotion/styled';
import Image from '@base/Image';
import { Spacings } from '@styles/index';
import H6 from '@base/H6/H6';
import P2 from '@base/P2/P2';
import ArrowRight from '@icon/ArrowRight';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import pushRoute from '@utils/pushRoute';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { segment } from '@actions/analytics';
import { REFERRAL_TOUCHPOINT_CLICKED } from '@constants/segment';
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const ReferFriendsCardWrapper = styled.div`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
  display: flex;
  background: var(--color-base-1);
  margin-top: ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  box-shadow: ${boxShadowGenerator()};
`;

const StyImage = styled(Image)`
  border-radius: ${Spacings.SPACING_2B};
  img {
    transform: scaleX(-1);
  }
`;

const LabelWrapper = styled.div`
  width: 70%;
`;

const SubLabel = styled(P2)`
  color: var(--color-text-secondary);
`;

const ReferFriendsCard = ({ goalUID }) => {
  const goalSegmentData = useGoalEventProps({ goalUID });
  const { data: referralStats } = useFetch(
    'v2/subscriptions/referrals/details/',
    { hostType: HOST_TYPE.BACKEND_API_HOST },
    { useCamelCase: false }
  );
  const {
    laptop_eligibility_referrals: { current_count, min_required_count } = {}
  } = referralStats ?? {};

  if (current_count >= min_required_count) return null;

  const handleClick = () => {
    pushRoute('/settings/referral', '/settings/referral');
    segment.track(REFERRAL_TOUCHPOINT_CLICKED, {
      ...goalSegmentData,
      last_primary_source_section: 'Planner Refer Side Card',
      referral_type: 'Paid'
    });
  };

  return (
    <ReferFriendsCardWrapper onClick={handleClick}>
      <StyImage
        src="settings/referral/refer-and-earn-alt.svg"
        alt="referral"
        width={40}
        height={40}
      />
      <LabelWrapper>
        <H6>Refer friends</H6>
        <SubLabel>Win a laptop, vouchers & more</SubLabel>
      </LabelWrapper>
      <ArrowRight size={24} color="var(--color-text-primary)" />
    </ReferFriendsCardWrapper>
  );
};

export default ReferFriendsCard;
